import type { ReactNode } from "react";

import { cn } from "@/shared/lib/utils";

interface ProseProps {
	children: ReactNode;
	className?: string;
}

/**
 * Typographic wrapper for a run of rich paragraphs in a bespoke doc page. There's
 * no `@tailwindcss/typography` in this package, so spacing/measure are applied here
 * with the existing theme tokens: a comfortable reading measure, relaxed leading,
 * and `text-foreground/90` body color (matching the prose treatment the old
 * markdown viewer used). Stacks vertical rhythm between child paragraphs.
 */
export function Prose({ children, className }: ProseProps) {
	return (
		<div
			className={cn(
				"max-w-prose space-y-4 text-[15px] leading-relaxed text-foreground/90 [&_strong]:font-semibold [&_strong]:text-foreground",
				className,
			)}
		>
			{children}
		</div>
	);
}
